import { BasicListItem } from './basic-list-item';
import { DisplaySchema } from './display-schema';
import { ViewConfig } from './view/view-config';
import { ViewType } from './view/view-info';

export class BasicListItemSchema extends DisplaySchema<BasicListItem> {
  refTitle = 'Basic List Item';
  refColumnList = {
    id: {
      propertyName: 'id',
      columnField: true
    },
    label: {
      propertyName: 'label',
      columnField: true,
      displayName: 'label'
    },
    value: {
      propertyName: 'value',
      columnField: true,
      displayName: 'Value'
    }
  };
  refViewModels: ViewConfig<BasicListItem>[] = [
    {
      id: 'Normal',
      name: 'Value',
      type: ViewType.Standard,
      viewColumns: ['value'],
      showNewButton: false
    }
  ];
  NewObject(jsonData?: Partial<BasicListItem>): BasicListItem {
    return new BasicListItem(jsonData);
  }
}
